import React from "react";

const HowItWorkCard = ({ info }) => {
  const { title, icon } = info;
  return (
    <div className="how-it-works-card">
      <div className="how-it-works-card__icon">
        <img src={icon} alt="" />
      </div>
      <p className="how-it-works-card__title">{title}</p>
    </div>
  );
};

export default HowItWorkCard;
